import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto } from '../../../js/ComponentManager'
import { Alert, Confirm } from "../../../js/ComponentManager";


import { Swiper, SwiperSlide } from "swiper/react";
import {Thumbs } from 'swiper';
import "swiper/css";
import 'swiper/css/thumbs';
 
 

/* 개발담당:양유빈
 * 화면기능:상품리스트에서 상품을 클릭 하고 상품상세 조회
 * 세부설명:
*/

export class GoodsDtl extends Component {
    static displayName = GoodsDtl.name;

    constructor(props) {
        super(props);
        this.state = {
            FirstImage: "",
            Title: "",
            Soldout_Yn: "N",
            thumbsSwiper: null
        };
        
        this.handleModify_Click = this.handleModify_Click.bind(this);
        this.SlideChange = this.SlideChange.bind(this);
        this.AlertClick = this.AlertClick.bind(this);
        this.handleZoom_Click = this.handleZoom_Click.bind(this);     

        this.watingClick = null;
        this.lastClick = 0;  

    }
    //초기화
    componentDidMount() {

        if (this.props.ContentState !== null) {
            this.CallGoodsData();
        }
    }
    GoodsDataSetProp = {
        CategoryModel: [],   
        GoodsCrdModel: [],   
        GoodsImgMgtModel: [], 
        GoodsLadryModel: [],
        GoodsMatalModel: [],
        GoodsMatchaModel: [],
        GoodsMatchaBaseModel:[],
        GoodsMgtModel: [],
        GoodsSizModel: [],
        GoodsPhotoModel: [],
        StyleKeywordModel: [],
        AgeModel: [],
        Action:""
    }
   
    async AlertClick() {
        if (this.GoodsDataSetProp.Action === "delete") {
            this.props.RenderComponent("GoodsList", this.props.ContentState);
        }
        else {
            this.CallGoodsData();
        }
        return false;
    }
    //삭제, 품절, 재 등록 처리
    async handleModify_Click(action) {

        
        let Goods_No = this.props.ContentState.Goods_No;
        let Model = { goods_no: Goods_No, action: action };
        
        try {
            let Data = await Big3Common.Post(`api/Goods/GoodsMgr/ModifyGoodsState`, Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.GoodsDataSetProp.Action = action;
                this.setState({ Title: Data.message });
                //확인후 AlertClick 호출
                Big3Common.ModalAlert(bootstrap, 'GoodsDtlAlert');
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("handleModify_Click: ", e)
        }

        return false;
    }
    //조회 데이터 호출
    async CallGoodsData() {
        try {
            
            Big3Common.Util.LoadingOn();
            let Goods_No = this.props.ContentState.Goods_No;
            let Data = await Big3Common.Get(`api/Goods/GoodsMgr/GetGoodsDtl/${Goods_No}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                Object.assign(this.GoodsDataSetProp, DataList);
                this.setState({ Soldout_Yn: this.GoodsDataSetProp.GoodsMgtModel[0].soldout_yn });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGoodsData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleZoom_Click = (event) => {

        const GoodsPhotoModel = this.GoodsDataSetProp.GoodsPhotoModel;
        let ContentState = this.props.ContentState;
        ContentState["GoodsPhotoModel"] = GoodsPhotoModel;
        if (event.detail === 2) {
            //pc버전
            this.props.RenderComponent("GoodsZoom", ContentState);
        }
        else {

            //모바일버전
            if (this.lastClick && event.timeStamp - this.lastClick < 250 && this.watingClick) {
                this.lastClick = 0;
                clearTimeout(this.watingClick);
                console.log("double click");
                this.watingClick = null;
                this.props.RenderComponent("GoodsZoom", ContentState);
            } else {
                this.lastClick = event.timeStamp;
                this.watingClick = setTimeout(() => {
                    this.watingClick = null;
                    console.log("single click");
                }, 251);
            }
        }
        event.preventDefault();
    }
    ClipBoard_Click= (content) => {
        navigator.clipboard.writeText(content)
            .then(() => {
                this.setState({ Title: "복사되었습니다." });
                //확인후 AlertClick 호출
                Big3Common.ModalAlert(bootstrap, 'GoodsDtlAlert');
                console.log('clipboard successfully!');
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    }
    Product1Clip_Click = (ColorName, SizeName, MatalName, Made_Nm, Sinsale_Nm, Ladry_CdNm) => {
        const Content = `색상: ${ColorName}\n사이즈: ${SizeName}\n혼용율: ${MatalName}\n제조국: ${Made_Nm}\n낱장여부: ${Sinsale_Nm}\n세탁법: ${Ladry_CdNm}`;
        this.ClipBoard_Click(Content);
    }
    Product2Clip_Click = (MatchaGrp) => {
        let Content = "";
        MatchaGrp.map(list => {
            let Info ="";
            list.Childlist.map(childs => {
                Info = `${list.matgrp_nm}: ${childs.matcha_nm}`;
            });
            Content += `${Info}\n`;
        });      
        this.ClipBoard_Click(Content);
        
    }
    //카테고리 바인딩
    Categoryrender() {
        let categorymodels = this.GoodsDataSetProp.CategoryModel;
        if (categorymodels.length>0) {
            let categorymodel = categorymodels[0];
            return (
                <div className="pre_Category">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">{categorymodel.man_nm}</li>
                        <li className="breadcrumb-item">{categorymodel.mid_nm}</li>
                        <li className="breadcrumb-item">{categorymodel.sub_nm}</li>
                    </ol>
                </div>
            );
        }
    }
    //수정,삭제, 입고, 품절, 재등록 버튼
    Modifiyrender() {
        
        const pathName = window.location.pathname.toLowerCase();
        //상품관리에서만 변경가능
        if (pathName !== "/goods/goodsmgr/index") {
            return (
                ""
            )
        }
        let soldout_yn = this.state.Soldout_Yn;
        let LinkUrl = `../../Goods/RegisterMgr/Index?goods_no=${this.props.ContentState.Goods_No}`;
        return (
            <div className="pre_btn_box">
                <Link to={LinkUrl} className="pre_btn">
                    <div>수정</div>
                    <div className="pre_icon pre_icon1"></div>
                </Link>
                <div className="pre_btn" onClick={() => {Big3Common.ModalAlert(bootstrap, 'ConfirmBox')}} >
                    <div>삭제</div>
                    <div className="pre_icon pre_icon2"></div>
                </div>
                <div className={soldout_yn === "Y" ? "pre_btn" : "pre_btn item_hide"} onClick={() => this.handleModify_Click('income')}>
                    <div>입고</div>
                    <div className="pre_icon pre_icon3"></div>
                </div>
                <div className={soldout_yn === "Y" ? "pre_btn item_hide" : "pre_btn"} onClick={() => this.handleModify_Click('soldout')}>
                    <div>품절</div>
                    <div className="pre_icon pre_icon3_1"></div>
                </div>
                <div className="pre_btn" onClick={() => this.handleModify_Click('reupload')}>
                    <div>재등록</div>
                    <div className="pre_icon pre_icon4"></div>
                </div>
            </div>
            );
    }
    //색상, 사이즈, 혼용률, 제조국, 낱장여부
    Product1render() {
        let GoodsCrdlist = this.GoodsDataSetProp.GoodsCrdModel;
        let ColorName = GoodsCrdlist.map(list => { return list.crd_nm }).toString().replaceAll(",", ", ");
        let GoodsSizlist = this.GoodsDataSetProp.GoodsSizModel;
        let SizeName = GoodsSizlist.map(list => { return list.siz_nm }).toString().replaceAll(",", ", ");
        let GoodsMatallist = this.GoodsDataSetProp.GoodsMatalModel;
        let MatalName = GoodsMatallist.map(list => { return `${list.matal_nm} ${list.ratio}% ` }).toString().replaceAll(",", ", ");
        let Made_Nm = "";
        let Sinsale_Nm = "";
        if (this.GoodsDataSetProp.GoodsMgtModel.length > 0) {
            Made_Nm = this.GoodsDataSetProp.GoodsMgtModel[0].made_by_nm;
            Sinsale_Nm = this.GoodsDataSetProp.GoodsMgtModel[0].sinsale_yn_nm;
        }
        let Ladry_CdNm = this.GoodsDataSetProp.GoodsLadryModel.map(list => { return list.ladry_cd_nm }).toString().replaceAll(",", ", ");
        return ( 
            <div className="protuct_intro">
                <div className="title">상품설명
                    <div className="copy_btn" onClick={() => { this.Product1Clip_Click(ColorName, SizeName, MatalName, Made_Nm, Sinsale_Nm, Ladry_CdNm) }}></div>
                </div>
                <div className="product_info_line first_line">
                    <div className="product_info_title">색상</div>
                    <div className="product_info_cont">{ColorName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">사이즈</div>
                    <div className="product_info_cont">{SizeName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">혼용률</div>
                    <div className="product_info_cont">{MatalName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">제조국</div>
                    <div className="product_info_cont">{Made_Nm}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">낱장여부</div>
                    <div className="product_info_cont">{Sinsale_Nm }</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">세탁법</div>
                    <div className="product_info_cont">{Ladry_CdNm}</div>
                </div>
            </div>
        );
    }
    //상품소재 특성
    Product2render() { 
        //소재정보 기준정보 값
        let GoodsMatchaBaseModel = Big3Common.Util.groupBy(this.GoodsDataSetProp.GoodsMatchaBaseModel, list => list.matgrp_nm);
        let GoodsMatchaModel = this.GoodsDataSetProp.GoodsMatchaModel;

        //render에 바인됭 리스트
        let MatchaGrp = [];
        //소재정보 셋팅
        for (const item of GoodsMatchaBaseModel.entries()) {
            //소재정보 리스트 세부 항목           
            let itemList = item[1];
            //클릭한 소재정보
            let SelectState = [];
            //소재정보에서 선택된 값이 있으면 설정
            itemList.forEach(function (items) {
                let EqualList = GoodsMatchaModel.filter(list => list.matcha_grp === items.matcha_grp && list.matcha_cd === items.matcha_cd);
               
                if (EqualList.length > 0) {
                    SelectState = EqualList;
                }
            });
            if (SelectState.length > 0) {
                MatchaGrp.push({ "matgrp_nm": item[0], "Childlist": item[1], "SelectState": SelectState[0] });
            }
        }
        return (
            <div className="protuct_intro">
                <div className="title">소재 정보
                    <div className="copy_btn" onClick={() => { this.Product2Clip_Click(MatchaGrp) }}></div>
                </div>
                {
                    MatchaGrp.map((list, idx) =>
                        <div className={idx === 0 ? "product_info_line first_line" : "product_info_line"} key={list.matgrp_nm}>
                            <div className="product_info_title">{list.matgrp_nm}</div>
                            {
                                list.Childlist.map(childs =>
                                <div className="form-check product_info_check" key={childs.matcha_grp + '_' + childs.matcha_cd}>
                                        <input className="form-check-input"
                                            type="checkbox"
                                            defaultChecked={childs.matcha_grp === list.SelectState.matcha_grp && childs.matcha_cd === list.SelectState.matcha_cd ? true : false}
                                            name={'matcha_' + childs.matcha_grp}
                                            disabled
                                            style={{ opacity: "inherit" }}

                                    />
                                        <label className="form-check-label" style={{ opacity: "inherit" }}>{childs.matcha_nm}</label>
                                </div>
                            )}
                        </div>
                    )}
            </div>
        );
       
    }
    SlideChange(e) {
        console.log(e);
    }
    //상품사진
    PhotoListrender() {
        let GoodsPhotoList = this.GoodsDataSetProp.GoodsPhotoModel;
        if (GoodsPhotoList.length > 0) {
            let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
            let TotalCount = GoodsPhotoList.length;
            let LayoutWidth = Big3Common.Util.offsetWidth();
            let slidersCount = 13;
            slidersCount = Math.ceil(LayoutWidth / 100) - 1;
            if (slidersCount >= 13) {
                slidersCount = 13;
            }
            else if (slidersCount <= 5) {
                slidersCount = 5;
            }
            return (
                <div>
                    <Swiper
                        spaceBetween={10}
                        navigation={false}
                        className="mySwiper2"
                        modules={[Thumbs]}
                        thumbs={{ swiper: this.state.thumbsSwiper }}
                    >
                        <>
                            {
                                GoodsPhotoList.map((list,idx) =>
                                    <SwiperSlide key={list.rownum} 
                                        onClick={this.handleZoom_Click}
                                    >
                                            <GoodsPhoto
                                            className="pre_main_img"
                                            ImageSrc={list.img_1000}
                                            BackGround={false}
                                            TotalCount={<div className="photo_number">{idx + 1}/{TotalCount}</div>}
                                            />
                                    </SwiperSlide>
                                )}
                        </>
                    </Swiper>
                    <Swiper watchSlidesProgress={true}
                        slidesPerView={slidersCount}
                        className="mySwiper img_list_box"
                        modules={[Thumbs]}
                        onSwiper={(swiper) => this.setState({ thumbsSwiper: swiper })}
                    >
                        <div>
                            {
                                GoodsPhotoList.map(list =>
                                    <SwiperSlide key={list.rownum}
                                        className="img_list"
                                        style={{ width: "65px", height: "65px", backgroundImage: `url(${VirtualRoot}${list.img_100})` }}
                                    >
                                    </SwiperSlide>
                                )}
                            <SwiperSlide style={{ width: "65px", height: "65px" }}>
                                {/* 공백*/}
                            </SwiperSlide>
                        </div>
                    </Swiper>
                </div>
            )
        }
        else {
            return "";
        }
       
    }
    render() {
        let Category = this.Categoryrender();
        let ModifiyLayer = this.Modifiyrender();
        let Product1 = this.Product1render();
        let Product2 = this.Product2render();
        let GoodsMgtModel = this.GoodsDataSetProp.GoodsMgtModel;
        let PhotoList = this.PhotoListrender();
        let Goods_Nm = "";
        let Goods_Price = "0"; 
        let Dtl_Content = "";
        let Reg_Dt = "";
        let Strqst_Yn = "N";
        let Overseas_Yn = "N";
        if (GoodsMgtModel.length > 0) {
            Goods_Nm = GoodsMgtModel[0].goods_nm;
            Goods_Price = GoodsMgtModel[0].goods_price;
            Dtl_Content = GoodsMgtModel[0].dtl_content;
            Reg_Dt = GoodsMgtModel[0].reg_dt;
            Strqst_Yn = GoodsMgtModel[0].strqst_yn;
            Overseas_Yn = GoodsMgtModel[0].overseas_yn;
        }
        return (
            <div className="pre_wrap">
                {PhotoList}
                <div className="pre_content_wrap">
                    {Category}
                    <div className="update">최신등록일자 : {Reg_Dt}</div>
                    <div className="pre_title">{Goods_Nm}</div>
                    <div className="pre_price">{Big3Common.Util.Money(Goods_Price)}원 {Strqst_Yn==="Y" ? "(매장문의)" : "" }</div>
                    {ModifiyLayer}
                    <div className="protuct_intro">
                        <div className="title">제품설명
                            <div className="copy_btn" onClick={() => { this.ClipBoard_Click(Dtl_Content) }}></div>
                        </div>
                        <div className="product_txt" style={{ whiteSpace: 'pre-line' }}>
                            {Dtl_Content }
                        </div>
                    </div>
                    {Product1}
                    {Product2}
                    {Overseas_Yn === "Y" ?
                        <div className="Usage_Consent">
                            <div className="Material_select_box">
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id="Overseas_Yn"
                                        checked={true }
                                        disabled={true}
                                    />
                                    <label className="form-check-label">
                                        해외에 판매되도록 이미지 사용에 동의했습니다.
                                    </label>
                                </div>
                            </div>
                        </div>
                        :
                        ""
                    }
                    
                </div>
                <Alert
                    id="GoodsDtlAlert"
                    content=""
                    title={this.state.Title}
                    AlertClick={this.AlertClick}
                />
                <Confirm
                    id="ConfirmBox"
                    title="삭제알림"
                    content="정말로 삭제하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);

                        this.handleModify_Click('delete');
                    }}
                />
            </div>
        );
    }
}
